import ReactGA from 'react-ga4';

import {AnalyticsCategory, AnalyticsEventName, AnalyticsOnboardingEventName} from 'enums';
import {logger} from 'utils/logger';

class AnalyticsService {
    private enabled: boolean;

    init(trackingId: string) {
        if (trackingId && !this.enabled) {
            ReactGA.initialize(trackingId);

            logger.debug({category: logger.category.Analytics, message: 'Google analytics is enabled'});
            this.enabled = true;
        } else {
            this.enabled = false;
        }
    }

    trackOnboardingEvent(name: AnalyticsOnboardingEventName, data = {}) {
        this.trackEvent(name, {...data, category: AnalyticsCategory.Onboarding});
    }

    private trackEvent(name: AnalyticsEventName, data?: any) {
        if (this.enabled) {
            ReactGA.event(name, data);
            logger.debug({category: logger.category.Analytics, message: 'Event sent'}, {name, data});
        }
    }
}

export const analyticsService = new AnalyticsService();